import axios from 'axios'

export default {
  bind: (el, binding, vnode) => {
    // const validations = ['required', 'maxLength', 'pattern', 'minLength', 'min', 'max']
    el.addEventListener('submit', e => {
      e.preventDefault()
      const parent = vnode.context
      let formHasError = false
      const formData = new FormData()
      parent.$children
        .filter(el => el.$el.dataset && el.$el.dataset.escape !== 'true')
        .forEach(component => {
          const elements = component.isMulti
            ? getListOfElement(component)
            : [component]

          for (let j = 0; j < elements.length; j++) {
            const element = elements[j]
            const child = element.component ? element.$children[0] : element

            child.$el.addEventListener('click', e => {
              child.errors = {}
            })

            let hasError = false
            const key = element.$el.dataset?.model || 'inputValue'
            const value = element[key]

            if (
              child.required ||
              (!child.required &&
                value !== undefined &&
                value !== null &&
                (value.length > 0 || value.size))
            ) {
              if (child.pattern) {
                const pattern = new RegExp(child.pattern)
                if (!pattern.test(value)) {
                  hasError = true
                }
              }
              if (
                (child.maxLength && value.length > child.maxLength) ||
                (child.minLength && value.length < child.minLength)
              ) {
                hasError = true
              }
              if (
                child.required &&
                (value === undefined ||
                  value === null ||
                  value.length === 0 ||
                  value.size === 0)
              ) {
                hasError = true
              }
              child.errors = hasError
                ? { message: child.$el.dataset.error }
                : {}

              formHasError = formHasError || hasError
              if (!hasError && value && !child.$el.dataset.skip) {
                if (component.isHouseKey && child.$el.dataset.name2) {
                  formulateData(
                    value,
                    formData,
                    element.name,
                    child.$el.dataset.name2,
                  )
                } else {
                  addValueToFormData(
                    element.name || element.$attrs.name,
                    value,
                    formData,
                  )
                }
              }
            }
          }
        })

      if (!formHasError) {
        submitForm(el, parent, formData)
      }
    })
    el.addEventListener('click', e => {
      if (e.target.dataset.reset) {
        const parent = vnode.context
        for (let i = 0; i < parent.$children.length; i++) {
          const element = parent.$children[i]
          const child = element.component ? element.$children[0] : element
          element.inputValue = child.value
          child.errors = {}
        }
      }
    })
  },
}

function formulateData(value, formData, name1, name2) {
  const valueTrimmed = value.trim()
  const numberPart = valueTrimmed.match(/^[0-9]+/g)
  if (numberPart) {
    formData.append(name1, numberPart)
    const rest = valueTrimmed.split(numberPart)[1]
    if (rest) {
      formData.append(name2, rest.trim())
    }
    //for plz ort the else case is prevented by validation alert, plz and ort are mandatory in backend
    //for number numberAddon this case is allowed, numberAddon is not mandatory
  } else {
    formData.append(name2, valueTrimmed)
  }
}

function getListOfElement(element) {
  return element.$children.reduce(
    (acc, curr) => (acc = [...acc, ...curr.$children]),
    [],
  )
}

function addValueToFormData(key, value, formData) {
  const valueType = Object.prototype.toString.call(value)
  const isArray = valueType === '[object Array]'
  const isObject = valueType === '[object Object]'

  if (isArray) {
    value.forEach(el => {
      formData.append(key, el)
    })
  } else if (isObject) {
    Object.keys(value).forEach(k => {
      formData.append(key, k)
      formData.append(key, value[k])
    })
  } else {
    formData.append(key, value)
  }
}

function showErrors(err, parent) {
  for (let i = 0; i < parent.$children.length; i++) {
    const element = parent.$children[i]
    const child = element.component ? element.$children[0] : element
    const error = (err.unsatisfiedFields || []).find(
      e => e.name === element.name,
    )
    if (error) {
      child.errors = { message: child.$el.dataset.error }
    }
  }
}

function submitForm(el, parent, formData) {
  if (parent.enctype === 'multipart/form-data') {
    formData.append(':formid', parent.id)
    formData.append(':formstart', parent.formstart)
    formData.append('_charset_', parent.charset)

    if (parent.redirect !== undefined) {
      formData.append(':redirect', parent.redirect)
    }

    if (parent.method === 'POST') {
      axios
        .post(parent.action, formData)
        .then(res => {
          const { data } = res
          if (data.successUrl !== undefined) {
            // jshint ignore:line
            window.location = data.successUrl
          }
        })
        .catch(err => {
          const { data } = err.response
          showErrors(data, parent)
        })
    }
  }
}
